import Masonry from 'masonry-layout';
import EventHandler from '@pixelunion/events';

export default class ProductMosaic {
  constructor(options = {}) {
    this.el = options.el || null;

    if (!this.el) {
      return console.warn('Unable to initiate ProductMosaic.js');
    }

    this.events = new EventHandler();

    this.el.querySelectorAll('video').forEach(video => {
      const event = this.events.register(video, 'loadeddata', () => {
        if (this.masonry) {
          this.masonry.layout();
        }
        this.events.unregister(event);
      });
    });

    this.masonry = new Masonry(
      this.el,
      {
        columnWidth: '.product-mosaic-sizer',
        gutter: '.product-mosaic-gutter',
        itemSelector: '.product-mosaic-media-figure',
        percentPosition: true,
      },
    );
  }

  destroy() {
    this.masonry.destroy();
    this.events.unregisterAll();
  }
}
